<h1 mat-dialog-title class="title">{{ data.title }}</h1>
<mat-dialog-content class="mat-typography content">
  <div class="data-entry" *ngIf="isHtml" [innerHTML]="data.message"></div>
  <div class="data-entry" *ngIf="!isHtml">
    {{ data.message }}
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-button class="confirm" (click)="onSubmit()">Confirm</button>
  <button mat-button class="close" mat-dialog-close (click)="onCancel()">
    Cancel
  </button>
</mat-dialog-actions>
